import { z } from 'zod';

export const RewardTypeV1 = {
  RATE: 1,
  AMOUNT: 2,
} as const;

export const ZodRewardTypeV1 = z.nativeEnum(RewardTypeV1);

export type RewardTypeV1 = z.infer<typeof ZodRewardTypeV1>;
